import React from 'react';
import './LoadingIndicator.css';

/**
 * Loading indicator component to show loading states
 * 
 * @param {Object} props - Component props
 * @param {string} props.size - Size of the indicator ('small', 'medium', 'large')
 * @param {string} props.label - Optional text to display with the spinner
 * @param {string} props.message - Optional status message (takes precedence over label)
 * @param {string} props.className - Additional CSS class names
 */
const LoadingIndicator = ({
  size = 'medium',
  label,
  message,
  className = '',
  ...rest
}) => {
  const baseClass = 'ui-loading-indicator';
  const sizeClass = `${baseClass}--${size}`;
  const classes = [baseClass, sizeClass, className].filter(Boolean).join(' ');

  // Use message prop if provided, otherwise use label
  const displayText = message || label;

  return (
    <div 
      className={classes} 
      data-testid="loading-indicator" 
      role="progressbar"
      aria-busy="true"
      aria-label={displayText || "Loading"}
      {...rest}
    >
      <div className="ui-loading-indicator__spinner" />
      {displayText && <div className="ui-loading-indicator__label">{displayText}</div>}
    </div>
  );
};

export default LoadingIndicator;